module.exports = __webpack_public_path__ + "img/icon-analytics.273273b9.svg";